import * as requests from "../coraWebComponents/utils/requests";

export const GUID = async (guid) => {
  try {
    let res = await requests.verify(null, `guid/${guid}`);
    return res;
  } catch (error) {
    throw error;
  }
};

export const emailAndPass = async (data) => {
  try {
    let res = await requests.verify(data, `emailAndPass`);
    return res;
  } catch (error) {
    throw error;
  }
};
